import ModuleBlock from "./ModuleBlock";
import PowerSupplyBusSegment from "./PowerSupplyBusSegment";

export default class PowerSupplyBus extends ModuleBlock {
  constructor(json) {
    super(json);
    this.segments = PowerSupplyBus.getMappedOrDefault(json, 'segments', [], data => (data || []).map(s => new PowerSupplyBusSegment(s || {})));
    this.consumption = PowerSupplyBus.getMappedOrDefault(json, 'consumption', 0, v => parseInt(v));
    this.maxConsumption = PowerSupplyBus.getMappedOrDefault(json, 'maxConsumption', 0, v => parseInt(v));
  }
}
